
// Angular
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable, forkJoin } from 'rxjs';
import { PermissionResourceService } from 'libraries/service/resources/permission/permissionResource.service';
import { IMenuItem } from 'libraries/component/popup-menu/popup-menu.component';
import {PROCESSING_WORDING, ProcessingService, ProcessingType} from "libraries/service/processing/processing.service";

@Injectable()
export class PopupMenuPermissionService {
    constructor(
        private readonly permissionService: PermissionResourceService,
        private readonly processingService: ProcessingService
    ) { }

    public getMenuItem(permissions: Array<{ permission: string, processing: ProcessingType }>, wording : {[key: string]: string} =  PROCESSING_WORDING ): Observable<IMenuItem[]> {
        const permissionObs = permissions
            .map(({ permission, processing }) =>
                this.permissionService.hasPermission(permission).pipe(
                    map((hasPermission) => ({ processing, hasPermission })
                    )));

        return forkJoin([...permissionObs])
            .pipe(
                map((processingPermissions: Array<{ processing: ProcessingType, hasPermission: boolean }>): Array<{ processing: ProcessingType, hasPermission: boolean }> =>
                    processingPermissions.filter(({ hasPermission }) => hasPermission)),
                map((processingPermissions: Array<{ processing: ProcessingType, hasPermission: boolean }>): IMenuItem[] =>
                    processingPermissions.map(({ processing }) => this.processingService.getMenuItemConfig(processing, wording))),
            );
    }
}
